import React from 'react'

function Shippingpolicy() {
    return (
        <div className="container " style={{ fontSize: '18px', textAlign: 'justify' }}>
           <h2 className='mt-3'><strong>Shipping policy</strong></h2>

           <p> There are no physical products, so no shipping needed.</p>

        </div>
    )
}

export default Shippingpolicy